import { JSX } from "react";
import cx from "classnames";
import { getNewPatientClaimsDefinitions } from "@app/projects/servicing-provider/ServicingProviderHelpers";
import InfoIndicator from "@app/shared/InfoIndicator";

interface NewPatientCPTInd {
  commercialNewPatientInd?: string;
  commercialClaimsVolumeDisplay?: string;
  medicaidNewPatientInd?: string;
  medicaidClaimsVolumeDisplay?: string;
  medicareNewPatientInd?: string;
  medicareClaimsVolumeDisplay?: string;
  vaNewPatientInd?: string;
  vaClaimsVolumeDisplay?: string;
  tricareNewPatientInd?: string;
  tricareClaimsVolumeDisplay?: string;
  totalNewPatientInd?: string;
  totalClaimsVolumeDisplay?: string;
}

/**
 * ProviderNewPatientCPTProps interface
 */
interface ProviderNewPatientCPTProps {
  newPatientIndicators: NewPatientCPTInd;
  showVA: boolean;
  showTricare: boolean;
  className?: string;
  testId: string;
}

/**
 * ProviderNewPatientCPT component
 * This component displays new patient claims indicators for a provider.
 */
const ProviderNewPatientCPT = (props: ProviderNewPatientCPTProps): JSX.Element => {
  return (
    <div
      className={cx({ [props.className]: !!props.className, "data-box": true })}
      data-testid={props.testId}
    >
      <div className="data-box-header">
        New Patient CPT <InfoIndicator className={"informational-indicator"} tooltipTitle={getNewPatientClaimsDefinitions()} />
      </div>
      <div className="data-box-content">
        Total: {!!props.newPatientIndicators.totalNewPatientInd ? props.newPatientIndicators.totalNewPatientInd : "---"}
      </div>
      <div className="data-box-content">
        Medicare: {!!props.newPatientIndicators.medicareNewPatientInd ? props.newPatientIndicators.medicareNewPatientInd : "---"}
      </div>
      <div className="data-box-content">
        Medicaid: {!!props.newPatientIndicators.medicaidNewPatientInd ? props.newPatientIndicators.medicaidNewPatientInd : "---"}
      </div>
      <div className="data-box-content">
        Commercial: {!!props.newPatientIndicators.commercialNewPatientInd ? props.newPatientIndicators.commercialNewPatientInd : "---"}
      </div>
      {props.showVA && (
        <div className="data-box-content">
          VA: {!!props.newPatientIndicators.vaNewPatientInd ? props.newPatientIndicators.vaNewPatientInd : "---"}
        </div>
      )}
      {props.showTricare && (
        <div className="data-box-content">
          TRICARE: {props.newPatientIndicators.tricareNewPatientInd ? props.newPatientIndicators.tricareNewPatientInd : "---"}
        </div>
      )}
    </div>
  );
};

export default ProviderNewPatientCPT;